import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  InputGroup,
  InputRightAddon,
  NumberInput,
  NumberInputField,
  Tooltip,
  HStack,
  Text,
  Icon,
} from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';
import { OffersParametersFormType } from './OfferParametersForm';

interface Props {
  withVk?: boolean;
}

const OfferDiscountFormControls: React.FC<React.PropsWithChildren<Props>> = ({
  withVk,
}) => {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors },
  } = useFormContext<OffersParametersFormType>();

  return (
    <>
      <FormControl isInvalid={!!errors.vk}>
        <FormLabel htmlFor="vk">
          <HStack spacing="2">
            <Text>{t('VK')}</Text>
            <Tooltip
              hasArrow
              shouldWrapChildren
              label={t('ADVISORY-CONVERSATION_OFFERS_VK-EXPLANATION')}
            >
              <Icon name="GeneralActionsQuestion" />
            </Tooltip>
          </HStack>
        </FormLabel>
        <InputGroup>
          <Controller
            control={control}
            name="vk"
            render={({ field: { ref, ...restField } }) => (
              <Tooltip
                label={!withVk && t(`No proxy rebate supported for this quote`)}
              >
                <NumberInput
                  id="vk"
                  precision={2}
                  placeholder={t('Proxy Rebate')}
                  clampValueOnBlur={false}
                  isDisabled={!withVk}
                  {...restField}
                >
                  <NumberInputField ref={ref} borderRightRadius="0" />
                </NumberInput>
              </Tooltip>
            )}
          />
          <InputRightAddon>%</InputRightAddon>
        </InputGroup>
        {errors.vk && (
          <FormErrorMessage justifyContent="flex-end">
            {errors.vk.message}
          </FormErrorMessage>
        )}
      </FormControl>
      <FormControl isInvalid={!!errors.ck}>
        <FormLabel htmlFor="ck">{t('CK')}</FormLabel>
        <InputGroup>
          <Controller
            control={control}
            name="ck"
            render={({ field: { ref, ...restField } }) => (
              <NumberInput
                id="ck"
                precision={2}
                placeholder={t('Commission Rebate')}
                clampValueOnBlur={false}
                {...restField}
              >
                <NumberInputField ref={ref} borderRightRadius="0" />
              </NumberInput>
            )}
          />
          <InputRightAddon>%</InputRightAddon>
        </InputGroup>
        {errors.ck && (
          <FormErrorMessage justifyContent="flex-end">
            {errors.ck.message}
          </FormErrorMessage>
        )}
      </FormControl>
    </>
  );
};

export default OfferDiscountFormControls;
